import { useTranslation } from "react-i18next";
import Range from "../../components/Range";
import { n } from "../../lib/format";
import { kwhYearOf, useWizard } from "./WizardContext";

export default function Step1Forbrug() {
  const { t } = useTranslation();
  const { state, dispatch } = useWizard();
  return (
    <div>
      <span className="font-mono text-xs uppercase tracking-[0.14em] text-accent-deep">{t("step1.kicker")}</span>
      <h2 className="mt-2.5 text-[clamp(26px,4.4vw,40px)]">{t("step1.title")}</h2>
      <p className="mb-6 mt-2 max-w-[54ch] text-ink-soft">{t("step1.help")}</p>

      <Range
        min={2000} max={50000} step={500} value={state.km}
        onChange={(v) => dispatch({ type: "set", field: "km", value: v })}
        label={t("step1.kmLabel")} display={`${n(state.km)} km`} lo="2.000" hi="50.000"
      />
      <Range
        min={120} max={280} step={5} value={state.wh}
        onChange={(v) => dispatch({ type: "set", field: "wh", value: v })}
        label={t("step1.whLabel")} display={`${state.wh} Wh/km`} lo={t("step1.whLo")} hi={t("step1.whHi")}
      />

      <div className="mt-2 flex items-center gap-3.5 rounded-m border border-dashed border-accent-deep bg-canvas px-5 py-4">
        <span className="font-display text-[32px] font-semibold text-pine">{n(kwhYearOf(state))}</span>
        <div>
          <small className="block font-mono text-[11px] uppercase tracking-[0.07em] text-ink-faint">{t("step1.readout")}</small>
          <strong className="font-mono text-[13px]">{t("step1.kwhUnit")}</strong>
        </div>
      </div>
    </div>
  );
}
